import { FormEditor } from './../../models/editors/form-editor.base.model';

export class Hidden extends FormEditor<any> {
    public controlType = 'hidden';
    public hidden = true;

    constructor(options: {} = {}) {
        super(options);
        this.hidden = true;
    }
}
